/**
 * @generated SignedSource<<1d2059a70c654db761b5caa91675a052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type AttemptsWithoutPassingQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
};
export type AttemptsWithoutPassingQuery$data = {
  readonly studentsAttemptedSkillsWithoutPassing: ReadonlyArray<{
    readonly firstName: string | null | undefined;
    readonly lastName: string | null | undefined;
    readonly publicUserId: string | null | undefined;
  }>;
};
export type AttemptsWithoutPassingQuery = {
  response: AttemptsWithoutPassingQuery$data;
  variables: AttemptsWithoutPassingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttemptsWithoutPassingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "studentsAttemptedSkillsWithoutPassing",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttemptsWithoutPassingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "studentsAttemptedSkillsWithoutPassing",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "78d35b5bc5da4f0beeefa8c8f310f910",
    "id": null,
    "metadata": {},
    "name": "AttemptsWithoutPassingQuery",
    "operationKind": "query",
    "text": "query AttemptsWithoutPassingQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n) {\n  studentsAttemptedSkillsWithoutPassing(filter: $filter) {\n    firstName\n    lastName\n    publicUserId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a14210d905e940a5fad01ed70018a63";

export default node;
